<global-modal>
  <h2 *ngIf="data.title"> {{ data.title }} </h2>
  <p *ngIf="data.subtitle" [innerHTML]="data.subtitle" class="mat-body-2"></p>
  <span *ngIf="data.text">{{ data.text }}</span>
  <span *ngIf="data.warning" class="mat-subtitle-2 text-warn">{{ data.warning }}</span>

  <ng-container *ngIf="data.simulation?.length">
    <strong>Simulation : </strong>
    <ul>
      <li *ngFor="let item of data.simulation">{{ item }}</li>
    </ul>
  </ng-container>

  <mat-form-field appearance="outline">
    <mat-label i18n>Confirm action</mat-label>
    <input matInput type="text" [formControl]="actionConfirm" [placeholder]="data.placeholder??''" (keydown)="handleKey($event)">
  </mat-form-field>

  <mat-dialog-actions fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="4px">
    <button [disabled]="!isValid" mat-flat-button color="primary" (click)="confirm()">
      {{ data.confirmButtonText | firstWordTitlecase }}
    </button>
    <button mat-button color="primary" (click)="close()">
      {{ data.cancelButtonText | firstWordTitlecase }}
    </button>
  </mat-dialog-actions>
</global-modal>
